import { connect } from 'react-redux';
import { openModal, sendAnalyticsModalView } from 'actionCreators';
import ModalLink from 'components/shared/ModalLink';

const mapDispatchToProps = (dispatch) => ({
  clickHandler: () => {
    dispatch(sendAnalyticsModalView('faq'));
    return dispatch(openModal('faq'));
  },
});

export default connect(null, mapDispatchToProps)(ModalLink);
